import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import logo from '@/assets/logo.png'

/**
 * Brand — логотип Центрики (`.brand` макета, F2-01: заменяет прежний бейдж-инициал «Ц» + подпись).
 * Название уже часть изображения, отдельного текста рядом нет. Переиспользуется на входе (lg) и в
 * верхней панели (sm) — меняется только высота, ширина подстраивается по пропорциям файла.
 */
export interface BrandProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'lg' | 'sm'
  name?: string
}

export const Brand = forwardRef<HTMLDivElement, BrandProps>(
  ({ className, size = 'lg', name = 'Центрика', ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center', className)} {...props}>
      <img
        src={logo}
        alt={name}
        className={cn('w-auto object-contain', size === 'lg' ? 'h-brand-lg' : 'h-brand-sm')}
      />
    </div>
  ),
)
Brand.displayName = 'Brand'
